import "core-js/modules/es.array.every";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.reduce";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.object.values";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.includes";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getMonthTargetCounter, getTotalCounter, getMonthTotalCounter } from '@/api/bairun/financialCenter';
import dateUtils from '@/utils/dateUtil';
import MultiLineChart from '@/components/Charts/MultiLineChart';
import NP from 'number-precision';
import { mapGetters } from 'vuex';
import moment from 'moment';
export default {
  name: 'SlotCounterStationSheet',
  components: {
    MultiLineChart: MultiLineChart
  },
  props: {
    start: {
      type: Number,
      required: true
    },
    end: {
      type: Number,
      required: true
    },
    totalId: {
      type: Number,
      default: 999
    },
    refIndex: {
      type: Number,
      required: true
    },
    totalCounterName: {
      type: String,
      default: ''
    },
    totalCounterDisplayName: {
      type: String,
      default: '趋势'
    },
    totalCounterKind: {
      type: String,
      default: ''
    },
    slotCounterName: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      loading: false,
      slotOption: '',
      selectedArea: '全部',
      totalStats: null,
      slotStats: null,
      compareTotalStats: null,
      compareSlotStats: null,
      groupData: [],
      xAxisData: [],
      yAxisDatas: {},
      compareMapping: [],
      metricsArr: ['销量近期趋势'],
      borderFix: ['合计/L', '合/L', '0#'],
      filterMapping: [{
        text: '佛山',
        value: '佛山'
      }, {
        text: '粤西',
        value: '粤西'
      }, {
        text: '外省',
        value: '外省'
      }],
      showStations: [],
      customColors: [{
        color: '#909399',
        percentage: 30
      }, {
        color: '#f56c6c',
        percentage: 60
      }, {
        color: '#e6a23c',
        percentage: 85
      }, {
        color: '#409eff',
        percentage: 99
      }, {
        color: '#67c23a',
        percentage: 100
      }],
      stationTarget: [],
      timeSlots: ['beforeNums']
    };
  },
  watch: {
    end: function end() {
      this.loadTarget(this.end);
      this.loadTotalData();
    },
    refIndex: function refIndex() {
      this.refIndexRefresh();
    }
  },
  computed: _objectSpread({}, mapGetters('stations', ['asyncStations'])),
  created: function created() {
    this.loadTarget(this.end);

    for (var i in this.asyncStations) {
      this.compareMapping.push({
        text: this.asyncStations[i]['statTag'],
        value: this.asyncStations[i]['ID'],
        sellerId: this.asyncStations[i]['ID']
      });
    }

    this.loadTotalData();
  },
  updated: function updated() {
    var _this = this;

    this.$nextTick(function () {
      _this.$refs.tableStation.doLayout();
    });
  },
  methods: {
    refIndexRefresh: function refIndexRefresh() {
      this.$refs.tableStation.doLayout();
    },
    npPlus: function npPlus() {
      var res = 0;

      for (var i in arguments) {
        res = NP.plus(res, arguments[i]);
      }

      return res;
    },
    filterHandler: function filterHandler(value, row, column) {
      for (var i in this.asyncStations) {
        if (this.asyncStations[i]['ID'] === row['sellerId'] && this.asyncStations[i]['statArea'] === value) {
          return true;
        }
      }

      return false;
    },
    filterChange: function filterChange(selected) {
      this.selectedArea = selected['area'] && selected['area'][0] ? selected['area'][0] : '全部';
    },
    progressFormat: function progressFormat(value) {
      return function () {
        return value + '%';
      };
    },
    cellStyle: function cellStyle(_ref) {
      var row = _ref.row,
          column = _ref.column;

      if (this.borderFix.includes(column.label)) {
        return 'border-right:1px solid #000000';
      }
    },
    numberFix: function numberFix(number, len) {
      return dateUtils.numberFix(number, len);
    },
    showDetail: function showDetail(number, len) {
      return dateUtils.numberFix(number, len);
    },
    sellerName: function sellerName(sellerId) {
      for (var i in this.asyncStations) {
        if (this.asyncStations[i].ID === sellerId) {
          return this.asyncStations[i]['statAbbr'];
        }
      }

      return '';
    },
    sellerTarget: function sellerTarget(sellerId, month) {
      if (!this.stationTarget || this.stationTarget.length === 0) {
        return 0;
      }

      for (var i in this.stationTarget) {
        if (this.stationTarget[i]['stationId'] === sellerId) {
          return this.stationTarget[i]['target'];
        }
      }

      return 0;
    },
    loadTarget: function loadTarget(datetime) {
      var _this2 = this;

      getMonthTargetCounter({
        'month': moment(datetime).format('YYYYMM')
      }).then(function (response) {
        _this2.stationTarget = response.data;
      });
    },
    getSummaries: function getSummaries(param) {
      var columns = param.columns,
          data = param.data;
      var sums = [];

      var _that = this;

      var endMonthValue = _that.timestamp2datestring(this.end / 1000, 'YYYYMM');

      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = '合计/L';
          return;
        }

        if (index === 6) {
          sums[index] = '';
          return;
        }

        var values;

        if (column.property === 'dailyCount') {
          values = data.map(function (item) {
            return Number(_that.sellerTarget(item['sellerId'], endMonthValue));
          });
        } else {
          values = data.map(function (item) {
            return Number(item[column.property]);
          });
        }

        if (!values.every(function (value) {
          return isNaN(value);
        })) {
          sums[index] = values.reduce(function (prev, curr) {
            var value = Number(curr);

            if (!isNaN(value)) {
              return NP.plus(prev, curr);
            } else {
              return prev;
            }
          }, 0);
          sums[index] = NP.round(sums[index], 2);
        } else {
          sums[index] = '-';
        }
      });
      sums[2] = sums[3] !== '-' && sums[3] > 0 ? NP.round(NP.times(NP.divide(sums[1], sums[3]), 100), 2) + '%' : '-';
      sums[5] = sums[3] !== '-' && sums[3] > 0 ? NP.round(NP.times(NP.divide(sums[4], sums[3]), 100), 2) + '%' : '-';
      return sums;
    },
    loadTotalData: function loadTotalData() {
      var _this3 = this;

      if (this.loading) {
        return;
      }

      this.loading = true;
      var descriptorData = {
        descriptors: [{
          type: 'ocosotpc',
          operator: 'dateOCOSOTPC',
          name: this.slotCounterName,
          start: this.end / 1000 - 24 * 60 * 60,
          end: this.end / 1000,
          search: this.totalId === 999 ? '' : this.totalId.toString()
        }]
      };
      getTotalCounter(descriptorData).then(function (response) {
        var tempGroupData = Object.values(response.data);
        _this3.groupData = tempGroupData.sort(function (a, b) {
          var orders = [10006, 10003, 10011, 10013, 10010, 10014, 10001, 10012, 10002, 10005, 10004, 10009, 10008, 10015]; // // console.log('sort orders', orders.indexOf(a.sellerId), orders.indexOf(b.sellerId))

          return orders.indexOf(a.sellerId) - orders.indexOf(b.sellerId);
        });
        _this3.loading = false;

        _this3.$refs.tableStation.doLayout();
      }).catch(function () {
        _this3.loading = false;
      });
    },
    getStationName: function getStationName(sellerId) {
      for (var i in this.asyncStations) {
        if (this.asyncStations[i].ID === sellerId) {
          return this.asyncStations[i]['stationName'];
        }
      }

      return '';
    },
    loadData: function loadData(sellerId) {
      var _this4 = this;

      if (this.loading) {
        return;
      }

      var stationName = this.getStationName(sellerId);
      this.loading = true;
      var descriptorData = {
        descriptors: [{
          type: 'ocosotpc',
          operator: 'dateOCOSOTPC',
          t: sellerId,
          name: this.slotCounterName,
          start: this.start / 1000,
          end: this.end / 1000,
          search: ''
        }]
      };
      getMonthTotalCounter(descriptorData).then(function (response) {
        _this4.loading = false;
        var stats = response.data; // console.log('getMonthTotalCounter', stationName, stats)

        _this4.totalStats = {};

        for (var x = _this4.start / 1000; x <= _this4.end / 1000; x += 24 * 3600) {
          var formatX = dateUtils.timeStampToString(x, 'MMDD');
          _this4.totalStats[formatX] = 0;

          for (var index in _this4.timeSlots) {
            var slot = _this4.timeSlots[index];

            if (stats[formatX] !== undefined && stats[formatX][slot] !== undefined) {
              _this4.totalStats[formatX] += stats[formatX][slot];
            }
          }
        }

        _this4.metricsArr = [stationName + '销量近期趋势']; // console.log('getMonthTotalCounter => totalStats', this.totalStats)

        _this4.updateRetentionTrend();
      }).catch(function () {
        _this4.loading = false;
      });
    },
    timestamp2datestring: function timestamp2datestring(ts) {
      var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      return dateUtils.timeStampToString(ts, format);
    },
    totalColumn: function totalColumn(ts) {
      if (!this.totalStats || this.totalStats[ts] === undefined) {
        return 0;
      } else {
        return this.numberFix(this.totalStats[ts], 2);
      }
    },
    updateRetentionTrend: function updateRetentionTrend() {
      this.xAxisData = [];
      this.yAxisDatas = {};

      if (this.metricsArr.length > 0) {
        for (var i in this.metricsArr) {
          var chartName = this.metricsArr[i];
          this.yAxisDatas[chartName] = [];
        }
      }

      for (var timestamp = this.start / 1000; timestamp <= this.end / 1000; timestamp += 24 * 3600) {
        var formatX = dateUtils.timeStampToString(timestamp, 'MMDD');
        this.xAxisData.push(formatX);

        if (this.metricsArr.length > 0) {
          var metric = this.metricsArr[0];

          if (!this.totalStats || this.totalStats[formatX] === undefined) {
            this.yAxisDatas[metric].push(0);
          } else {
            this.yAxisDatas[metric].push(this.totalColumn(formatX));
          }
        }
      } // console.log(111, this.xAxisData)
      // console.log(222, this.yAxisDatas)

    }
  }
};